import Api from 'src/api/Base'

class GetGroupById extends Api {
  requestUrl = `/api/Group/${this.getParams().id}`
}
export default GetGroupById
